import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const NoticeboardDetails = () => {

    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });

    return formattedDate;
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [noticeboardData, setNoticeboardData] = useState([])
    const query = useQuery()


    const FetchCommunities = async (isSpace) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch( isSpace ?
            `${BASE_URL}/community/noticeboard/getbyspce/${query.get("space")}`:
            `${BASE_URL}/community/noticeboard/getbycm/${query.get("community")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setNoticeboardData(data.response);
            // setloading(false);
        }

    };


    const RearrangeNoticeboard = async (slidesData) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(query.get('space') ?
            `${BASE_URL}/community/noticeboard/rearrange_space_data/${query.get("space")}` :
            `${BASE_URL}/community/noticeboard/rearrange_cm_data/${query.get("community")}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                slides: slidesData
            })
        });
        const data = await response.json();
        alert(data.response)

    };

    useEffect(() => {
        if (query.get("space")) {
            FetchCommunities(true)
        } else {
            FetchCommunities(false);
        }
    }, []);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [communitites, setCommunities] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')
    const [items, setItems] = useState(["One", "Two", "Three", "Four", "qw", "weq"]);

    const onDragStart = (e, index) => {
        e.dataTransfer.setData("drag-index", index);
    };

    const onDrop = (e, index) => {
        const dragIndex = e.dataTransfer.getData("drag-index");
        const newItems = [...noticeboardData];
        const draggedItem = newItems[dragIndex];
        newItems.splice(dragIndex, 1);
        newItems.splice(index, 0, draggedItem);
        setNoticeboardData(newItems);
        RearrangeNoticeboard(newItems)
    };


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>

                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        pb={"20px"}
                        sx={{ flexWrap: 'wrap', flexDirection: 'row', display: 'flex' }}
                    >
                        {noticeboardData.map((item, index) => (
                            <div
                                key={index}
                                draggable
                                onDragStart={(e) => onDragStart(e, index)}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={(e) => onDrop(e, index)}
                                style={{
                                    width: "350px",
                                    aspectRatio: 16 / 9,
                                    border: "2px solid #202020",
                                    borderRadius: 5,
                                    overflow: 'hidden',
                                    display: 'flex',
                                    position: 'relative',
                                    background: "#aaaaaa20"
                                }}
                            >
                                <img src={item.mediaUrl} style={{ width: "100%", height: "100%", }} />

                                <Box sx={{
                                    position: 'absolute', top: 5, left: 5, width: "25px", height: "25px", borderRadius: "100px", background: "#ffffff",
                                    color: "#303030", fontFamily: "poppins-mid", alignItems: 'center', justifyContent: 'center', display: 'flex',
                                    justifyItems: 'center',
                                }}>{index + 1}</Box>
                            </div>
                        ))}
                    </Box>

                </Box>

            </Box>
        </>
    );
}

export default NoticeboardDetails;
